import React, { useState } from 'react';
import { array, bool, string, func } from 'prop-types';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import useStyles from 'hooks/useStyles';
import BaseModal from 'components/BaseModal';
import Button from 'components/Button';

import styles from './AvailableLessonModal.scss';

dayjs.extend(customParseFormat);

const LEGAL_DAYJS_FORMAT = 'YYYY-MM-DDTHH:mm:ss.000ZZ';
const EXPIRED_TIME_FORMAT = 'YYYY/MM/DD'; // ex: 2022/12/22
const LESSON_TIME_FORMAT = 'MMM D, YYYY h:mm A'; // ex: Nov 21, 2022 10:00 AM

export default function AvailableLessonModal({
  lessons,
  lastDay,
  isSemester,
  onPurchaseButtonClick,
  onAvaliableLessonClick,
}) {
  useStyles(styles);
  const { t } = useTranslation(['live', 'purchase']);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAvaliableLessonClick = () => {
    onAvaliableLessonClick();
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className={styles.root}>
      <div className={styles.cta} onClick={handleAvaliableLessonClick}>
        {t('purchase:purchase.content.subscriptions.checkAvailableEpisodes')}
      </div>
      {isModalOpen && (
        <BaseModal
          closable
          title={t('topic.availableEpisode.title')}
          isFullMode={false}
          buttons={
            <Button
              onClick={onPurchaseButtonClick}
              text={t('topic.availableEpisode.button')}
            />
          }
          onClose={closeModal}
          isScrollable
        >
          {isSemester
            ? t('topic.availableEpisode.semesterDescription')
            : t('topic.availableEpisode.subscriptionDescription', {
                date: dayjs(lastDay, LEGAL_DAYJS_FORMAT).format(
                  EXPIRED_TIME_FORMAT,
                ),
              })}
          <ul className={styles.ul}>
            {lessons.map(({ id, name, startAt }) => (
              <li key={id} className={styles.list}>
                <div className={styles.name}>{name}</div>
                {!isSemester && (
                  <div>
                    {dayjs(startAt, LEGAL_DAYJS_FORMAT).format(
                      LESSON_TIME_FORMAT,
                    )}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </BaseModal>
      )}
    </div>
  );
}

AvailableLessonModal.propTypes = {
  lessons: array.isRequired,
  isSemester: bool.isRequired,
  onPurchaseButtonClick: func.isRequired,
  onAvaliableLessonClick: func.isRequired,
  lastDay: string,
};

AvailableLessonModal.defaultProps = {
  lastDay: '',
};
